export default "/images/ba64248db6c3e8c53ccc3678eaf26ae7.avif";